/**
 * Session cache for the paginated inventory items list so navigating away from
 * /inventory and back does not refetch the same page/search/filters.
 * Cleared on logout (see redux/store.js) and when data is explicitly refreshed or mutated.
 */
let cached = null;

export function getInventoryListCacheKey({
  page,
  rowsPerPage,
  search,
  categoryId,
  lowStockOnly,
  missingPrice,
  priceTypes,
}) {
  return JSON.stringify({
    p: page ?? 0,
    r: rowsPerPage ?? 10,
    q: search ?? "",
    c: categoryId ?? "",
    l: lowStockOnly ? 1 : 0,
    m: missingPrice ? 1 : 0,
    pt: priceTypes ?? "",
  });
}

export function readInventoryListCache(key) {
  if (!cached || cached.key !== key) return null;
  return {
    items: cached.items,
    totalCount: cached.totalCount,
  };
}

export function writeInventoryListCache(key, items, totalCount) {
  cached = {
    key,
    items: Array.isArray(items) ? items : [],
    totalCount: Number(totalCount) || 0,
  };
}

export function invalidateInventoryListCache() {
  cached = null;
}
